import {
  FETCH_HELP_DETAIL_CONTENT,
  FETCH_HELP_DETAIL_CONTENT_SUCCESS,
  FETCH_HELP_DETAIL_CONTENT_FAILED,
  SEARCH_HELP_RESULT_CONTENT,
  SEARCH_HELP_RESULT_CONTENT_SUCCESS,
  SEARCH_HELP_RESULT_CONTENT_FAILED
} from "../actions/actionTypes";

const initialState = {
  isLoading: true,
  content: {},
  records: null,
  isSearching: false,
  error: false
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_HELP_DETAIL_CONTENT:
      return {
        ...state,
        isLoading: true,
        content: {}
      };
    case FETCH_HELP_DETAIL_CONTENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        records: payload.records,
        content: payload
      };
    case FETCH_HELP_DETAIL_CONTENT_FAILED:
      return {
        ...state,
        isLoading: false,
        content: {},
        error: payload
      };
    case SEARCH_HELP_RESULT_CONTENT:
      return {
        ...state,
        isSearching: true
      };
    case SEARCH_HELP_RESULT_CONTENT_SUCCESS:
      return {
        ...state,
        records: payload.records,
        isSearching: false
      };
    case SEARCH_HELP_RESULT_CONTENT_FAILED:
      return {
        ...state,
        isSearching: false
      };
    default:
      return state;
  }
}
